var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginman" }, [
    _c("div", { staticClass: "Footnavbar" }, [
      _c("div", { staticClass: "foot-in" }, [
        _c("div", { staticClass: "l" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "help faq",
              on: {
                click: function($event) {
                  return _vm.toFaq()
                }
              }
            },
            [
              _c("img", {
                staticClass: "icon",
                attrs: { src: require("../../../assets/images/faq.png") }
              }),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "r" }, [
          _c("div", { staticClass: "f-t" }, [
            _c("span", { staticClass: "f-t1" }, [
              _vm._v("报名期间（工作日）咨询时间:")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "f-t2" }, [
              _vm._v(_vm._s(_vm.linkTime)),
              _c("span", { staticStyle: { margin: "0 15px" } }),
              _vm._v("15:00-18:00")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "f-t" }, [
            _c("span", { staticClass: "f-t1" }, [
              _vm._v("网上报名系统操作咨询:")
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("span", { staticClass: "f-t2" }, [_vm._v(_vm._s(_vm.linktel))])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("../../../assets/images/help.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://gkzpfw.com/static/help_manual.pdf",
              target: "_blank"
            }
          },
          [_vm._v("帮助手册")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p" }, [_c("a", [_vm._v("常见问题")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { display: "block", margin: "20px" } }, [
      _vm._v("技术支持： 广西麒睿信息技术有限公司 ICP备案号："),
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" } },
        [_vm._v("桂ICP备17006471号")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10656717", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10656717","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/components/Foot.vue
// module id = null
// module chunks = 